import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickPricesValidatorParams } from '@ordersnproducts/modules/one-click-order/selectors/one-click-prices-validator.selector';

export class OneClickPriceDisablerProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(getOneClickPricesValidatorParams).pipe(
      filter(state => !!state),
      map(state => state.blockedPrices),
    );
  }
}
